export default __webpack_public_path__ + "tb-swagger-ui.min.css";